import { CONSTANT } from '../../utils/constant.js'

export default class cartService {
  // noinspection JSAnnotator
  productChunks = [];

  /**
   * updates current cart object
   */

  /* eslint-disable complexity */
  updateCart (product, quantity, productId) {
    this.cartDetails = this.getCartDetails()
    let products = this.cartDetails['products']
    let itemCount = this.cartDetails['itemCount']
    let subtotal = this.cartDetails['subtotal']

    // If product already in cart, add to existing quantity
    // Otherwise, value is quantity
    // Clean product

    if (undefined !== products && products[productId] != null) {
      products[productId].cartQuantity += quantity
    } else {
      // Clean product
      var keepers = ['productId', 'price', 'salePrice', 'name', 'image', 'facets', 'cartQuantity', 'description', 'reviewRating',
        'reviewContent', 'attribute2', 'attribute3', 'attribute1', 'category']
      var cleanProduct = {}
      for (var i in keepers) {
        cleanProduct[keepers[i]] = product[keepers[i]]
      }

      // Add passed product data to product list
      products[productId] = cleanProduct
      products[productId].cartQuantity = quantity
    }
    // Calculate new cart count and total price
    let price = products[productId].salePrice || products[productId].price
    itemCount = itemCount + quantity
    subtotal = subtotal + (quantity * price)

    // If less than 0 of given product
    // Remove from cart and product list
    if (products[productId].cartQuantity <= CONSTANT.CART_DETAILS.ZERO) {
      delete products[productId]

      // If cart is empty, reset all cart data
      // if (Object.keys(products).length === CONSTANT.CART_DETAILS.ZERO) {
      //   itemCount = CONSTANT.CART_DETAILS.ZERO
      //   subtotal = CONSTANT.CART_DETAILS.ZERO
      // }
    }
    this.products = products
    // TODO: is this needed
    this.itemCount = itemCount
    this.subtotal = subtotal

    this.cartDetails.products = products
    this.cartDetails.itemCount = itemCount
    this.cartDetails.subtotal = subtotal
    this.cartDetails.tax = subtotal * CONSTANT.CART_DETAILS.TAX
    this.cartDetails.shipping = CONSTANT.CART_DETAILS.SHIPPING
    this.cartDetails.digital = CONSTANT.CART_DETAILS.DIGITAL
    this.cartDetails.totalPrice = subtotal + this.cartDetails.shipping + this.cartDetails.tax
    localStorage.setItem('cartDetails', JSON.stringify(this.cartDetails))
    return this.cartDetails
  }

  getCartDetails () {
    const cartDetails = JSON.parse(localStorage.getItem('cartDetails'))

    if (cartDetails) {
      return cartDetails
    } else {
      return {
        products: {},
        itemCount: CONSTANT.CART_DETAILS.ZERO,
        subtotal: CONSTANT.CART_DETAILS.ZERO,
        shipping: CONSTANT.CART_DETAILS.ZERO,
        totalPrice: CONSTANT.CART_DETAILS.ZERO,
        tax: CONSTANT.CART_DETAILS.ZERO,
        digital: CONSTANT.CART_DETAILS.DIGITAL
      }
    }
  }
}
